import axios from 'axios';

export function fetchWebApi(queryName, qry) {
  return axios.get(queryName).then(response => response.data);
}
